export const PARAMETER_MENU_CONSTANT = '200px';
